import React, { useState, useMemo } from "react";
import styles from "./EventMembersTab.module.css";

import Card from "../../../shared/Card";
import EventMembersList from "../EventMembersList";
import SearchBar from "../../Shared/SearchBar";

import testEvents from "./testData";

/**
 * Events/Members Tab component
 */

export function EventMembersTab({ id }) {
  const [_id, setId] = useState(null);
  const [eventMembers, setEventMembers] = useState(null);

  const [sortedEventMembers, setSortedEventMembers] = useState(null);

  useMemo(() => {
    id && id !== null && setId(id);
  }, [id]);

  useMemo(() => {
    _id !== null &&
      // map through data (currently test data)
      testEvents.some(
        (event) => event.id === _id && setEventMembers(event.eventMembers) && setSortedEventMembers(event.eventMembers)
      );
  }, [_id]);

  function onSearch(searchText) {
    alert(searchText)
    // let term = searchText.toString().toLowerCase();
    // if (term !== "") {
    //   setSortedEventMembers(
    //     eventMembers.filter(function (member) {
    //       return (
    //         member.iboNumber.toString().toLowerCase().includes(term) ||
    //         member.name.toLowerCase().includes(term) ||
    //         member.tempAccount.toLowerCase().includes(term) ||
    //         member.dateAdded.toLowerCase().includes(term) ||
    //         member.attended.toLowerCase().includes(term)
    //       );
    //     })
    //   );
    // } else {
    //   setSortedEventMembers(eventMembers);
    // }
  }

  return (
    <>
      <Card className={styles.cardContainer}>
        <div className={styles.header}>
          <h4>TICKET HOLDERS</h4>
        </div>

          <SearchBar
              onInput={(searchText) => onSearch(searchText)}
              placeholderText={"Search by IBO #, IBO Name, IBO email address"}
              searchDelay={0}
              minChar={0}
              className={styles["search-bar"]}
              btn={true}
            />

        <div className={styles.scrollContainer}>
          <div className={styles.cardContentContainer}>
            <EventMembersList eventMembers={eventMembers} />
          </div>
        </div>
      </Card>
    </>
  );
}
